import script from "./BanUserModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BanUserModal.vue?vue&type=script&lang=ts&setup=true"

import "./BanUserModal.vue?vue&type=style&index=0&id=e989d0a8&lang=scss&scoped=true"
script.__scopeId = "data-v-e989d0a8"

export default script